export default __webpack_public_path__ + "static/media/CNo.49-0.f6f8b645.jpg";